/**
 * What Desk tells a product about its own tickets, without being asked.
 *
 * The ingress is one-way: a product raises a ticket and then has to poll to learn anything. A
 * callback is the other direction, and it is deliberately thin. It says what happened and gives
 * the caller the same client-safe view `GET /support/tickets/:id` returns — nothing about who is
 * working on it, what was said internally, or how the routing went. Those are Ashniva's business.
 */
/** Every event a product may subscribe to. */
export const SUPPORT_CALLBACK_EVENT = {
    TICKET_CREATED: 'ticket.created',
    TICKET_ASSIGNED: 'ticket.assigned',
    TICKET_WAITING_CLIENT: 'ticket.waiting_client',
    TICKET_IN_PROGRESS: 'ticket.in_progress',
    TICKET_RESOLVED: 'ticket.resolved',
    TICKET_CLOSED: 'ticket.closed',
    /** A public reply. Never an internal note — those have no event and no shape here. */
    SUPPORT_UPDATE: 'support.update',
};
export const SUPPORT_CALLBACK_EVENTS = Object.values(SUPPORT_CALLBACK_EVENT);
export const SUPPORT_CALLBACK_EVENT_LABELS = {
    'ticket.created': 'Ticket accepted',
    'ticket.assigned': 'Someone picked it up',
    'ticket.waiting_client': 'Waiting for the client',
    'ticket.in_progress': 'Work started or resumed',
    'ticket.resolved': 'Resolved',
    'ticket.closed': 'Closed',
    'support.update': 'Public reply added',
};
/** Header names a receiver reads. Written down once so the docs and the sender agree. */
export const SUPPORT_CALLBACK_HEADERS = {
    SIGNATURE: 'X-Ashniva-Signature',
    DELIVERY: 'X-Ashniva-Delivery',
    EVENT: 'X-Ashniva-Event',
    TIMESTAMP: 'X-Ashniva-Timestamp',
};
/**
 * How long a receiver should accept a signed timestamp for.
 *
 * The signature covers the timestamp, so an attacker cannot move it; what it bounds is *replay*
 * of a genuine delivery captured off the wire. Five minutes is long enough for a slow queue and a
 * clock a little out of step, and short enough that a captured body stops being useful quickly.
 */
export const SUPPORT_CALLBACK_REPLAY_WINDOW_SECONDS = 300;
//# sourceMappingURL=support-callbacks.js.map